import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './HorizontalDivider.module.scss.js';

var _excluded = ["children", "className", "withLine"];
var HorizontalDivider = function HorizontalDivider(_ref) {
  var children = _ref.children,
    className = _ref.className,
    withLine = _ref.withLine,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx(styles.divider, withLine && styles.withLine, children && styles.withChildren, className)
  }, props), /*#__PURE__*/React.createElement("span", null, children));
};
HorizontalDivider.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Whether there will be text used for the children (which adds a line to the left and right of the text) */
  withLine: PropTypes.bool
};
HorizontalDivider.defaultProps = {
  withLine: false
};

export { HorizontalDivider as default };
//# sourceMappingURL=index.js.map
